var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisapprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#B73D3D",
    fillOpacity: 0.31
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 11.615L28.385 9.5L20 17.885L11.615 9.5L9.5 11.615L17.885 20L9.5 28.385L11.615 30.5L20 22.115L28.385 30.5L30.5 28.385L22.115 20L30.5 11.615Z",
    fill: "#B73D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisapprove);
export default __webpack_public_path__ + "static/media/disapprove.53ba96a41883cd3dadf6f82e2b454342.svg";
export { ForwardRef as ReactComponent };